// extracted by mini-css-extract-plugin
export default {"component":"SitemapSection__component-t6pF"};